import api from '../../api/axios';

// Action Types
export const GET_PAYMENT_METHODS_REQUEST = 'GET_PAYMENT_METHODS_REQUEST';
export const GET_PAYMENT_METHODS_SUCCESS = 'GET_PAYMENT_METHODS_SUCCESS';
export const GET_PAYMENT_METHODS_FAILURE = 'GET_PAYMENT_METHODS_FAILURE';

export const GET_STRIPE_CONNECT_REQUEST = 'GET_STRIPE_CONNECT_REQUEST';
export const GET_STRIPE_CONNECT_SUCCESS = 'GET_STRIPE_CONNECT_SUCCESS';
export const GET_STRIPE_CONNECT_FAILURE = 'GET_STRIPE_CONNECT_FAILURE';

// Get Payment Methods Action
export const getPaymentMethods = () => async (dispatch) => {
  try {
    dispatch({ type: GET_PAYMENT_METHODS_REQUEST });
    const response = await api.get('stripe/payment-methods');
    const data = response?.data || {};
    dispatch({ type: GET_PAYMENT_METHODS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    console.error('Payment methods API error:', error);
    
    // Handle 404 errors gracefully
    if (error?.response?.status === 404) {
      const errorMessage = 'Payment methods endpoint not available';
      dispatch({ type: GET_PAYMENT_METHODS_FAILURE, error: errorMessage });
      // Don't throw error for 404, just return empty data
      return { success: false, is_payment_method: false, message: errorMessage };
    }
    
    // Handle other errors
    const errorMessage = error?.response?.data?.message || 
                        error?.message || 
                        'Failed to fetch payment methods';
    dispatch({ type: GET_PAYMENT_METHODS_FAILURE, error: errorMessage });
    
    // Return empty data instead of throwing error to prevent component crashes
    return { success: false, is_payment_method: false, error: errorMessage };
  }
};

// Get Stripe Connect Action
export const getStripeConnect = () => async (dispatch) => {
  try {
    dispatch({ type: GET_STRIPE_CONNECT_REQUEST });
    const response = await api.get('stripe/connect');
    const data = response?.data || {};
    dispatch({ type: GET_STRIPE_CONNECT_SUCCESS, payload: data });
    return data;
  } catch (error) {
    console.error('Stripe connect API error:', error);
    
    // Handle 404 errors gracefully
    if (error?.response?.status === 404) {
      const errorMessage = 'Stripe connect endpoint not available';
      dispatch({ type: GET_STRIPE_CONNECT_FAILURE, error: errorMessage });
      // Don't throw error for 404, just return empty data
      return { data: null, message: errorMessage };
    }
    
    // Handle other errors
    const errorMessage = error?.response?.data?.message || 
                        error?.message || 
                        'Failed to fetch stripe connect data';
    dispatch({ type: GET_STRIPE_CONNECT_FAILURE, error: errorMessage });
    
    // Return empty data instead of throwing error to prevent component crashes
    return { data: null, error: errorMessage };
  }
};
